import { render, staticRenderFns } from "./newsAll.vue?vue&type=template&id=261ae842&scoped=true"
import script from "./newsAll.vue?vue&type=script&lang=js"
export * from "./newsAll.vue?vue&type=script&lang=js"
import style0 from "./newsAll.vue?vue&type=style&index=0&id=261ae842&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ae842",
  null
  
)

export default component.exports